// extracted by mini-css-extract-plugin
export default {"button":"common_button__qFt4-","labelContainer":"common_labelContainer__IHK2B"};